module.exports = __webpack_public_path__ + "static/scale-model-of-springfield-museums-in-springfield-massachusetts-9c2442e9b6a1cbc32f5e585bf91c92e7.png";